<template>
  <WorkPackageSubPageModule
    :workpackage="workpackage"
    :isMobile="isMobile"
    :location="location"
    :loading="loading"
    :is_create_screen="is_create"
    :header_options="isEditMode ? [
      {description: 'Delete', icon: 'bin-delete', show: !is_create && isEditMode, delete_btn_loading: delete_btn_loading},
    ] : ''"
    :background_color="workpackage_bg_hex"
    :foreground_color="workpackage_fg_hex"
    header_icon="qr-code"
    header_text_short="QR"
    header_text_long="QR.code"
    @headerCancel="$router.push({name: `${location}WorkPackageQRCodes`, params: { nav_back: $route.params.nav_back} })"
    @headerBack="$router.push({name: `${location}WorkPackageQRCodes`, params: { nav_back: $route.params.nav_back} })"
    @headerSave="create()"
    @clickHeaderDelete="
      delete_btn_loading = true,
      deleteQRCode({
        project_id,
        workpackage_id,
        prefix,
        tag: qr_code,
      }).then(() => {
        delete_btn_loading = false;
        $router.push({name: `${location}WorkPackageQRCodes`, params: { nav_back: $route.params.nav_back} })
      })
    "
    >
    <template #header-rightside>
    </template>
    <template #body>
      <CollapsableCategory
        v-if="is_create"
        value="link QR-Code"
        :color="workpackage_fg_hex"
        :init_expanded="true"
        :watch_is_collapsed="show_scanner"
      >
        <template #content="{ is_collapsed, }">
            <div class="qr-scanner" v-if="!is_collapsed">
              <qrcode-stream @decode="onDecode"></qrcode-stream>
              <!-- <qrcode-drop-zone @decode="onDecode">
                DROP ME
              </qrcode-drop-zone> -->
            </div>
        </template>
      </CollapsableCategory>
      <DisableableInputField
        class="mt-2 mb-2"
        label="Code"
        :value="qr_code.code"
        :is_disabled="true"
        :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex"
      />
      <DisableableInputField
        class="mt-2 mb-2"
        label="Description"
        align="left"
        :value="qr_code.description"
        :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex"
        @change="changeQRDescription($event)"
      />
      <DropDownOutlinedFlat
        label="Link"
        :options="qr_link_types"
        :value="{text: qr_link.text, value: qr_link.value}"
        :is_disabled="!is_create"
        :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex"
        @change="changeQRLinkType($event)"
        style="width: 100%;"
      />
      <DropDownOutlinedFlat
        v-if="qr_link.value !== `${prefix}workpackages`"
        label="Step"
        :options="qr_link_steps"
        :value="{text: qr_link_steps.find(step => step.value === qr_link.id).text, value: qr_link.id}"
        :is_disabled="!is_create"
        :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex"
        @change="changeQRLinkStep($event)"
        style="width: 100%;"
      />
      <DisableableInputField
        class="mt-2 mb-2"
        label="User"
        :value="is_create ? qr_code.user : qr_code.user_email.first_name + ' ' + qr_code.user_email.last_name"
        :is_disabled="true"
        :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex"
      />
      <DisableableInputField
        v-if="!is_create"
        class="mt-2 mb-2"
        label="Created"
        :value="qr_code.created"
        :is_disabled="true"
        :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex"
      />
    </template>
  </WorkPackageSubPageModule>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';

import { WorkPackageReworkMixin } from '@/mixins/WorkPackageRework.mixin.js'

// import TText from '@/components/Taktify/TText.component.vue';
import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/WorkPackageSubPageModule.module.vue';
import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue'
import CollapsableCategory from '@/components/WorkPackageWIP/CollapsableCategory.component.vue';
import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue';



  export default {
    components: {
      WorkPackageSubPageModule,
      DisableableInputField,
      // TText,
      CollapsableCategory,
      DropDownOutlinedFlat
    },
    mixins: [
      WorkPackageReworkMixin
    ],
    props: ['location'],

    data: () => ({
      show_scanner: true,
      linked: false,
      new_qr_code: {
        code: '',
        signature: '',
        description: '',
        user: '',
        link_type: '',
        link_id: ''
      },
    }),
    mounted() {
      if (this.is_create) {
        this.new_qr_code.user = `${this.current_user.first_name} ${this.current_user.last_name}`;
        this.new_qr_code.link_type = `${this.prefix}workpackages`;
      } else if (this.qr_code.link_type != `${this.prefix}workpackages`) {
        this.loading = true;
        this.loadSteps(this.qr_code.link_type).then(() =>{
          this.loading = false;
        });
      }
    },
    computed: {
      ...mapGetters('Ultra', [
        'getUObjects'
      ]),
      ...mapState('Ultra', [
        'step_types',
        'tags'
      ]),
      ...mapState('Auth', [
        'current_user'
      ]),
      qr_code(){
        if (!this.is_create && this.tags[this.content_id]) {
          return this.tags[this.content_id];
        }
        else {
          return this.new_qr_code;
        }
      },
      // list of all link types (steps if wp contains steps)
      qr_link_types() {
        let link_types = [{text: 'WORK.package', value: `${this.prefix}workpackages`, disabled: false}]
        this.step_types.forEach(type => {
          if (!['robotic', 'cost'].includes(type)) {
            let text = `${type.toUpperCase()}.step`;
            let value = `${this.prefix}${type}steps`;
            let name_for_route = `${type.substring(0,1).toUpperCase()}${type.substring(1)}`;
            let disabled = true;
            if (this.workpackage[value] && this.workpackage[value].length !== 0) {
              disabled = false;
            } else if (this.workpackage[`${this.prefix}${type}_step_count`] && this.workpackage[`${this.prefix}${type}_step_count`] !== 0) {
              disabled = false;
            }
            link_types.push({
              text: text,
              value: value,
              disabled: disabled,
              name_for_route: name_for_route,
            })
          }
        });
        return link_types;
      },
      // current qr link
      qr_link() {
        let link = {value: `${this.prefix}workpackages`, id: this.workpackage_id, text: 'WORK.package'}
        this.qr_link_types.forEach(link_type => {
          if (link_type.value !== `${this.prefix}workpackages` && this.qr_code.link_type === link_type.value) {
            link.value = link_type.value;
            link.text = link_type.text;
            link.name_for_route = link_type.name_for_route;
            link.id = this.qr_code.link_id;
          }
        });
        return link;
      },
      qr_link_steps() {
        return this.workpackage[this.qr_link.value].map(id => {
          return {text: this.$store.state.Ultra[this.qr_link.value][id].text, value: id, disabled: false};
        });
      },
    },
    methods: {
      ...mapActions('Ultra', [
        'createUObject',
        'updateUObject',
        'deleteUObject',
        'updateUObjectPosition',
        'requestUObject'
      ]),
      ...mapActions('TWorkPackage', [
        'validQRCode',
        'createQRCode',
        'deleteQRCode'
      ]),
      ...mapActions('View', [
        'setUserFeedback'
      ]),

      loadSteps(step_type) {
        return new Promise((resolve) => {
          this.requestUObject({
            url: this.workpackage_url.concat([
              {[step_type]: ''},
              {showWithEntitiesNormalized: ''}
            ]),
            add_u_object: true
          }).then(() => {
            resolve();
          });
        })
      },
      changeQRDescription(evt){
        if (this.is_create) {
          this.new_qr_code.description = evt;
        } else {
          this.updateUObject({
            url: [
              {projects: this.project_id},
              {tags: this.qr_code.id},
            ],
            update: {
              description: evt
            }
          })
        }
      },
      changeQRLinkStep(evt){
        this.new_qr_code.link_id = evt;
      },
      changeQRLinkType(evt){
        if(evt !== `${this.prefix}workpackages`) {
          this.loadSteps(evt).then(() => {
            this.new_qr_code.link_id = this.workpackage[evt][0];
            this.new_qr_code.link_type = evt;
          });
        } else {
          this.new_qr_code.link_id = this.workpackage_id;
          this.new_qr_code.link_type = evt;
        }
      },
      onDecode(decoded){
      // https://www.takting.com/codes?code=9FECF10C9C&signature=
      // console.log(decoded);
      // let index_code = decoded.indexOf('?code=');
      let code = decoded.substring(35, 45);
      let signature = decoded.substring(56);
      this.validQRCode({code, signature, project_id: this.project_id})
        .then(() => {
          this.new_qr_code.code = code;
          this.new_qr_code.signature = signature;
          this.show_scanner = false;
        })
      },
      create(){
        let promises = [];
        if (this.new_qr_code.code !== '') {
          promises.push(
            this.createQRCode({
              code: this.new_qr_code,
              workpackage_id: this.workpackage_id,
              workpackage_url: this.workpackage_url,
              prefix: this.prefix
            })
          );
          Promise.all(promises).then(() => {
            this.$router.push({
              name: `${this.location}WorkPackageQRCodes`,
              nav_back: this.$route.params.nav_back,
            })
          })
        } else {
          this.setUserFeedback('Missing QR.code');
        }
      }
    },
  }
</script>

<style>
.work-package-qr-detail-linkheader{
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
/* .work-package-image-detail-img-edit {
    position: absolute;
    right: 0px;
    z-index: 10;
    margin: 5px;
  } */
.work-package-image-detail-img-container {
    position: relative;
    width: 100%;
    height: 200px;
    border: 1px solid rgba(0,0,0, 0.25);
    border-radius: 4px;
    overflow: hidden;
    flex-shrink: 0;
  }
.qr-scanner {
    border: 1px solid rgba(0,0,0, 0.25);
    height: 250px;
    border-radius: 4px;
    z-index: 15;
  }
  .qr-scanner-cancel {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 18;
  }
</style>
